module.exports = __webpack_public_path__ + "static/img/logo-big.e56662c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-big.png
// module id = Fgx8
// module chunks = 1